import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let reset = document.querySelector('[paws-component="noss-elearning"][paws-template="default"] [type="reset"]');
    if (reset !== undefined) {
        reset.addEventListener('click', function (event) {
            let frm = event.target.closest('form');
            if (frm) {
                setTimeout(function(){
                    htmx.trigger(frm, 'submit');
                }, 50);
            }
        });
    }
}
